// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_k6-0";
export var discountCodeInput = "_k6-1";